<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Graph</h4>
  <button type="button" class="close" (click)="modal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body relay-word-wrap" id="modal-body">
  <div class="row">
    <div class="col-6">
        <ng-select id="browser-type" searchable="true" class="mb-2 ml-2" [items]="dataType" [(ngModel)]="selectedDataType" placeholder="Select Data Type" dropdownPosition="bottom" (ngModelChange)="updateGraph()"></ng-select>
    </div>
    <div class="col-6" *ngIf="selectedDataType === 'Count'">
      <ng-select id="browser-type" searchable="true" class="mb-2 ml-2" [items]="countGraphTypes" [(ngModel)]="selectedGraphType" placeholder="Select Graph Type" dropdownPosition="bottom" (ngModelChange)="updateGraph()"></ng-select>
    </div>
    <div class="col-6" *ngIf="selectedDataType === 'Response Time'">
        <ng-select id="browser-type" searchable="true" class="mb-2 ml-2" [items]="responseTimeGraphTypes" [(ngModel)]="selectedGraphType" placeholder="Select Graph Type" dropdownPosition="bottom" (ngModelChange)="updateGraph()"></ng-select>
      </div>
  </div>
  <div id="pie-graph"></div>
</div>
